import * as React from 'react';
import { compose } from 'redux';

import Navbar from '../../../Navbar';
import { useTranslation } from '@shopee-user/platform';
import { SignupHelpButton } from '../../../NavbarHelpButton';
import SignupByOtpTip from '../../../SignupByOtpTip';

import {
  withUserWebView,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';
import { Layout, useResponsiveLayout } from '@shopee-user/layout-responsive';
import { isFeatureEnabled } from '@shopee-user/spx-customization-logic';
import { Feature } from '@shopee-user/feature-toggle';

type Props = {
  shouldHideBack: boolean;
} & WithUserWebViewProps;

function RequirePhoneHeader({
  shouldHideBack,
  // WithUserWebviewProps
  webViewNavigateBack,
}: Props) {
  const I18n = useTranslation();
  const { layout } = useResponsiveLayout();

  const DesktopSignupTip = !isFeatureEnabled(
    Feature.SignupByOtpHideSignupTip
  ) &&
    layout === Layout.Desktop && <SignupByOtpTip />;

  return (
    <>
      <Navbar
        title={I18n.t('label_auth_signup')}
        onClickBack={() => webViewNavigateBack()}
        rightContent={<SignupHelpButton text={I18n.t('label_auth_help')} />}
        shouldHideBack={shouldHideBack}
      />
      {DesktopSignupTip}
    </>
  );
}

export default compose<React.ComponentType<Props>>(withUserWebView({}))(
  RequirePhoneHeader
);
